<template>
    <span class="app-table-item-slot">
        <app-table-default-value v-if="!value || showDefaultValue" :value="defaultValue" />

        <template v-if="value && !showDefaultValue">
            <app-link :to="_.isFunction(value.header.to) ? value.header.to(value) : value.header.to">
                <span v-if="!_.isNil(value.header.prepend)">
                    <template v-if="_.isFunction(value.header.prepend)">
                        {{ value.header.prepend(value) }}
                    </template>
                    <template v-else>
                        {{ value.header.prepend }}
                    </template>
                </span>

                <slot />

                <span v-if="!_.isNil(value.header.append)">
                    <template v-if="_.isFunction(value.header.append)">
                        {{ value.header.append(value) }}
                    </template>
                    <template v-else>
                        {{ value.header.append }}
                    </template>
                </span>
            </app-link>
        </template>
    </span>
</template>

<script>
export default {
    name: 'ItemSlot',
    components: {
        AppTableDefaultValue: () => import(/* webpackChunkName: "core" */ './DefaultValue')
    },
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array],
            default: null
        },
        showDefaultValue: {
            type: Boolean,
            default: false
        },
        defaultValue: {
            type: String,
            default: null
        }
    }
};
</script>
